export class SSPTabs {
    static USERS = 'users'
    static GROUPS = 'groups'
    static FLAGS = 'flags'
    static HOURS = 'hours'
    static CONFIG = 'config'
    static HOLIDAYS = 'holidays'
    static PROMPTS = 'prompts'
}